import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';

export const ViewHeader = {
	copyViewLinkButtonClicked: (event: UIAnalyticsEvent) => {
		// https://data-portal.internal.atlassian.com/analytics/registry/47649
		fireUIAnalytics(event, 'button clicked', 'copyViewLinkButton');
	},
};
